/**
 * Provider to provide utility function for some route pre-processing
 * @author Umer Hassan
 */

function routeConfigProvider() {
  /**
   * use createRouteParams(paramsString) to create an object of params with 'dynamic' field to
   * be true, this is a temporary hack function until filterService & searchService are refactored
   */

  // TODO: remove createRouteParams method during searchService OR filterService refactor
  this.createRouteParams = function createParams(paramsString) {
    // add any separators you want to get rid of, except &
    const separators = ['{', '}', ':any', ' ', '\n'];
    const separatorsRegEx = new RegExp(separators.join('|'), 'g');

    // utilize & to obtain an array of all params
    const paramsList = paramsString.replace(separatorsRegEx, '').split('&');
    const params = {};
    paramsList.forEach((val) => {
      params[val] = {
        dynamic: true
      };
    });
    return params;
  };

  this.$get = () => ({
    createRouteParams: this.createRouteParams
  });
}

module.exports = (ngModule) => {
  ngModule.provider('routeConfig', [routeConfigProvider]);
};
